import { AdminPageHeader } from "../../components/admin/AdminPageHeader";
import { EmptyState } from "../../components/ui/EmptyState";

export function TrainerExercisesPage() {
  return (
    <div>
      <AdminPageHeader
        eyebrow="Coaching content"
        title="Exercise library"
        description="Reusable exercise explanations will live here."
      />
      <EmptyState title="Exercise library management is not built yet.">
        Plan assignment V1 focuses on assigning existing meal and workout plans.
      </EmptyState>
    </div>
  );
}
